module.exports = __webpack_public_path__ + "img/fc9da54.png";